import React from 'react';
interface LogoProps {
  className?: string;
  light?: boolean;
  size?: 'sm' | 'md' | 'lg';
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/k6RBzypFNS2uib6Rzze1BA/ChatGPT_Image_May_24,_2026_at_08_37_15_PM.png';
export function Logo({
  className = '',
  light = false,
  size = 'md'
}: LogoProps) {
  const sizeClasses = {
    sm: 'h-10',
    md: 'h-14',
    lg: 'h-20'
  };
  return <img src={LOGO_URL} alt="Compass Moving — Moving with direction, integrity, and excellence" className={`${sizeClasses[size]} w-auto object-contain ${className}`} data-id="element-181" />;
}